import { render } from "./our-pick-badge.vue?vue&type=template&id=3652b6c9&scoped=true"
import script from "./our-pick-badge.vue?vue&type=script&lang=js"
export * from "./our-pick-badge.vue?vue&type=script&lang=js"

import "./our-pick-badge.vue?vue&type=style&index=0&id=3652b6c9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3652b6c9"]])

export default __exports__